import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a]">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="eyebrow mb-6">
            <span className="gold-line" />
            Privacy Policy
          </div>
          <h1 className="font-heading text-4xl md:text-5xl text-white leading-[1.05]">
            Privacy Policy
          </h1>
          <p className="mt-6 text-[#a1a1aa]">
            Effective date: {new Date().toLocaleDateString("en-CA", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 space-y-10">
          <Block title="About This Policy">
            <p>
              Agent Marketing is a branded division of Kostaja Ltd. This
              Privacy Policy applies to any personal information collected
              through the agentmark.ca website and any Agent Marketing
              services. Kostaja Ltd. is the official company responsible for
              the operation of the Agent Marketing brand.
            </p>
          </Block>

          <Block title="Information We Collect">
            <p>We may collect the following categories of information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Contact information you provide through forms, such as name, email, phone number, profession, company, and location.</li>
              <li>Information about the services you are interested in and your business stage.</li>
              <li>Basic technical data such as browser type, device, and pages visited, collected through analytics.</li>
            </ul>
          </Block>

          <Block title="How We Use Information">
            <ul className="list-disc pl-6 space-y-2">
              <li>To respond to inquiries and provide services you request.</li>
              <li>To send service communication such as onboarding, project updates, and important notices.</li>
              <li>To improve our website, offerings, and client experience.</li>
              <li>For internal analytics and reporting.</li>
            </ul>
          </Block>

          <Block title="Analytics And Tracking">
            <p>
              We may use analytics tools and pixels to understand how visitors
              use the site. This helps us improve content and performance. You
              can control cookies through your browser settings.
            </p>
          </Block>

          <Block title="Sharing Of Information">
            <p>
              We do not sell your personal information. We may share limited
              information with trusted service providers who help us operate
              the website, deliver services, or communicate with you. These
              providers are required to protect your information.
            </p>
          </Block>

          <Block title="Data Retention">
            <p>
              We retain information only for as long as necessary to serve the
              purposes described above or as required by law. You may request
              deletion or update of your information at any time by contacting
              us.
            </p>
          </Block>

          <Block title="Your Choices">
            <ul className="list-disc pl-6 space-y-2">
              <li>You may request access, update, or deletion of your personal information.</li>
              <li>You may unsubscribe from marketing communications at any time.</li>
              <li>You may contact us with questions or concerns about this policy.</li>
            </ul>
          </Block>

          <Block title="Contact">
            <p>
              For any privacy-related requests, contact:{" "}
              <a
                href="mailto:contact@kostaja.ca"
                className="text-[#C8A24B] hover:underline"
              >
                contact@kostaja.ca
              </a>
              .
            </p>
            <p>
              Kostaja Ltd. is the official company behind Agent Marketing.
              Learn more at{" "}
              <a
                href="https://kostaja.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C8A24B] hover:underline"
              >
                kostaja.ca
              </a>
              .
            </p>
          </Block>

          <div className="pt-10 border-t border-[#27272a]">
            <Link to="/terms" className="text-sm text-[#C8A24B] hover:underline">
              Read our Terms and Service Notes →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-heading text-2xl text-white mb-4">{title}</h2>
      <div className="text-[#d4d4d8] leading-relaxed space-y-3">{children}</div>
    </div>
  );
}
